export default __webpack_public_path__ + "static/media/dashboard_orange.ff950586.svg";